import { NumberInput, NumberInputField, NumberInputFieldProps, NumberInputProps, useMergeRefs } from '@chakra-ui/react';
import { ChangeEvent, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { SimpleField, SimpleXProps } from './SimpleField';
import { useSimpleFormContext } from './SimpleForm';

export type SimpleNumberProps = SimpleXProps &
  NumberInputProps & { inputAttrs?: NumberInputProps & NumberInputFieldProps };

export const SimpleNumber = forwardRef(
  (
    { name, label, placeholder, helper, size = 'md', ignoreOnBlur, inputAttrs = {}, ...rest }: SimpleNumberProps,
    ref,
  ) => {
    const { simpleOnBlur } = useSimpleFormContext();
    const { register, setValue, watch } = useFormContext();

    const value = watch(name);
    const formProps = register(name);
    const mergedRef = useMergeRefs(formProps.ref, ref);

    const onChange = (_valueAsAString: string, valueAsANumber: number) => {
      setValue(name, isNaN(valueAsANumber) ? null : valueAsANumber);
    };

    const onBlur = (event: ChangeEvent<HTMLInputElement>) => {
      if (ignoreOnBlur) return;

      formProps.onBlur(event);
      simpleOnBlur(event);
    };

    return (
      <SimpleField<NumberInputProps> name={name} label={label} helper={helper} {...rest}>
        <NumberInput
          variant="filled"
          size={size}
          onBlur={onBlur}
          value={value ?? ''}
          {...inputAttrs}
          _focus={{
            borderColor: 'accent !important',
          }}
          onChange={onChange}
        >
          <NumberInputField
            type="number"
            step=".01"
            placeholder={placeholder}
            {...inputAttrs}
            {...formProps}
            _focus={{
              borderColor: 'accent !important',
            }}
            ref={mergedRef}
          />
        </NumberInput>
      </SimpleField>
    );
  },
);
